(()=> {
    window.addEventListener("DOMContentLoaded", ()=> {
        const text = document.getElementById('product-tabs_more');
        const btnMore = document.getElementById('toggleReadBtn');  
        const btnLess = document.getElementById('toggleLessBtn');  

        if (!btnMore || !text) return;
    
        function checkLines(){
          if (text?.classList.contains('expanded')) {
            btnMore.style.display = 'none';
            btnLess.style.display = 'flex';
            return;
          } else {
            btnLess.style.display = 'none';
          }
    
          const lineHeight = parseFloat(getComputedStyle(text).lineHeight);
          const lines = (text.clientHeight - 12) / lineHeight;
    
          if (lines >= 3 && text.scrollHeight > 84) {
            btnMore.style.display = 'flex';
          } else {
            btnMore.style.display = 'none';
            btnLess.style.display = 'none';
          }
        }
        checkLines();
    
        btnMore?.addEventListener('click', () => {
          text?.classList.add('expanded');
          btnMore.parentElement.style.maxHeight = `${btnMore.parentElement.scrollHeight}px`;
          checkLines();
        });
        btnLess?.addEventListener('click', () => {
            text?.classList.remove('expanded');
            btnLess.parentElement.style.maxHeight = `${btnLess.parentElement.scrollHeight}px`;
            checkLines();
          });
        window.addEventListener('resize', checkLines);
    })
})()
